module.exports = __webpack_public_path__ + "static/media/home_brown.93b5238f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/navbar/home_brown.svg
// module id = 2069
// module chunks = 0